import React from "react";

import { ContactContainer, Row, Button, Col } from "./index.style";
import { Container } from "../index.style";

const Contact = () => {
  return (
    <ContactContainer>
      <Container>
        <Row>
          <Col className="col">
            <h3>Ready to post a job today? Get started in 5 minutes.</h3>
            <Button href="/employers/post-job"> Post a Job </Button>
          </Col>
          <Col className=" col flex-rows-break"></Col>
          <Col className="col">
            <h3>See how QuirkyCoders can work best for your business.</h3>
            <Button href="/contact-us">Contact Us</Button>
          </Col>
        </Row>
      </Container>
    </ContactContainer>
  );
};

export default Contact;
